export default "__VITE_ASSET__D4ez7PH8__"